module.exports = __webpack_public_path__ + "static/minerva-1f644226f1571299ae4a1b07ad6a2997.png";